import { Component, OnInit } from '@angular/core';
import { SeguroAdesaoServices } from 'src/app/services/seguro/seguro-adesao.service';
import { Tab2PersonalizarComponent } from './tab2-personalizar/tab2-personalizar.component';
import { Tab3DeclaracaoSaudeComponent } from './tab3-declaracao-saude/tab3-declaracao-saude.component';
import { Tab4FinalizarAdesaoComponent } from './tab4-finalizar-adesao/tab4-finalizar-adesao.component';
import { Tab1SobreComponent } from './tab1-sobre/tab1-sobre.component';


@Component({
    selector: 'app-seguro-adesao',
    templateUrl: './seguro-adesao.component.html',
    styleUrls: ['./seguro-adesao.component.css'],
    imports: [Tab1SobreComponent, Tab2PersonalizarComponent, Tab3DeclaracaoSaudeComponent, Tab4FinalizarAdesaoComponent]
})
export class SeguroAdesaoComponent implements OnInit {

  elegivel: number;

  constructor(private seguroAdesao: SeguroAdesaoServices) {   
    this.elegivel = parseInt(localStorage.getItem("elegivelSeguro"));
  }

  ngOnInit() {
  }  
}
